import { Subject, BehaviorSubject } from 'rxjs';
import { ModelFactory } from '@angular-extensions/model';
import { ReportFilter, ISettingsFilter, SettingsFilter, IFilterBaseModel, FilterBaseModel, IMarketModel } from '../../models';
import { LocalStoreManager } from '@app/shared/services/local-store-manager.service';
import { DBkeys } from '@app/settings';
import * as i0 from "@angular/core";
import * as i1 from "@angular-extensions/model";
import * as i2 from "../../shared/services/local-store-manager.service";
const initialData = new SettingsFilter(10, 'gb', 'Car', 36, 60);
const initialFilterBase = FilterBaseModel.empty();
import * as _ from 'lodash';
export class ReportFilterService {
    constructor(_modelFactory, _localStorage) {
        this._modelFactory = _modelFactory;
        this._localStorage = _localStorage;
        this._filter = new Subject();
        this._filterSettings = new BehaviorSubject(initialData);
        //consume events - this.subscription = this.reportFilterService.filter$.subscribe(n => {  this.reportFilter = n; });
        this.filter$ = this._filter.asObservable();
        this.filterSettings$ = this._filterSettings.asObservable();
        var filterBaseLastState = this.loadLocalStore(DBkeys.FILTER_BASE);
        this._model = this._modelFactory.create(Object.assign({}, initialFilterBase, filterBaseLastState));
        this.active$ = this._model.data$;
    }
    //rise an event -  this.reportFilterService.filterChanged(filter: ReportFilter);
    filterChanged(filter) {
        this._filter.next(filter);
    }
    filterSettingsChanged(filter) {
        this._filterSettings.next(filter);
    }
    get currentActive() {
        return this._model.get();
    }
    update(model) {
        const vModel = this._model.get();
        if (model) {
            model.countryIds && model.countryIds.length > 0 && (vModel.countryIds = model.countryIds);
            model.vTypes && model.vTypes.length > 0 && (vModel.vTypes = model.vTypes);
            this._model.set(vModel);
        }
        this.saveToLocalStore(_.cloneDeep(vModel), DBkeys.FILTER_BASE);
    }
    //not used
    updateFromMarketModel(model) {
        const vModel = this._model.get();
        if (model.length) {
            vModel.countryIds = [...new Set(model.map(item => item.countryId))].sort();
            vModel.vTypes = [...new Set(model.map(item => item.vType))].sort();
            this._model.set(vModel);
        }
        this.saveToLocalStore(_.cloneDeep(vModel), DBkeys.FILTER_BASE);
    }
    loadLocalStore(key) {
        if (this._localStorage.exists(key))
            return this._localStorage.getDataObject(key);
    }
    saveToLocalStore(data, key) {
        setTimeout(() => this._localStorage.saveSessionData(data, key));
    }
}
ReportFilterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportFilterService_Factory() { return new ReportFilterService(i0.ɵɵinject(i1.ModelFactory), i0.ɵɵinject(i2.LocalStoreManager)); }, token: ReportFilterService, providedIn: "root" });
